import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, CircularProgress } from 'investira.react.components';

const AvalicoesSaveStatus = memo(({ modified = null, saving = false }) => {
  const pvFormatarDataHora = pData => {
    if (!pData) {
      return '--';
    }

    const xData = new Date(pData);
    if (Number.isNaN(xData.getTime())) {
      return '--';
    }

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(xData);
  };

  const xDataAtualizacao = pvFormatarDataHora(modified);

  return (
    <Stack direction="row" gap={1} alignItems="center" justifyItems="revert">
      <Typography variant="caption" color="textSecondary">
        Última atualização: {xDataAtualizacao}
      </Typography>
      {saving ? <CircularProgress size={12} sx={{ verticalAlign: 'middle' }} /> : null}
    </Stack>
  );
});

AvalicoesSaveStatus.propTypes = {
  modified: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  saving: PropTypes.bool
};

export default AvalicoesSaveStatus;
